import { ReactNode, forwardRef, HTMLAttributes } from 'react';
import { useResponsive } from '@/hooks/useResponsive';

interface ViewProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  children: ReactNode;
}

/**
 * Mobile/Tablet view (< 1024px)
 * Renders with layout styling for mobile/tablet bottom-bar layout
 */
export const View = forwardRef<HTMLDivElement, ViewProps>(({ className = '', children, ...props }, ref) => {
  const { isDesktop } = useResponsive();
  if (isDesktop) return null;

  return (
    <div
      ref={ref}
      className={`
        lg:border pointer-events-none fixed bottom-0 left-0 right-0 flex flex-col justify-end lg:justify-start max-h-full lg:gap-5 h-dvh lg:h-full w-full lg:w-100 lg:py-10 z-20 overflow-y-auto
        ${className}
      `}
      {...props}
    >
      {children}
    </div>
  );
});

View.displayName = 'View';
